// extracted by mini-css-extract-plugin
module.exports = {"lockup":"Lockup_lockup__zeOeC","mark":"Lockup_mark__EQPTu","text":"Lockup_text__aHw9V","hero":"Lockup_hero__BAGPz","small":"Lockup_small__Dghb_"};